import React, { useState } from 'react';
import './ResultsTable.css';

const ResultsTable = ({ results }) => {
  const [activePage, setActivePage] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');

  const currentPageResult = results[activePage];
  const entries = currentPageResult?.entries || [];

  const filteredEntries = entries.filter(entry => {
    const searchLower = searchTerm.toLowerCase();
    return (
      (entry.name?.toLowerCase().includes(searchLower)) ||
      (entry.place?.toLowerCase().includes(searchLower)) ||
      (entry.amount?.toString().includes(searchLower))
    );
  });

  const allEntries = results.flatMap((r, idx) => 
    (r.entries || []).map(e => ({ ...e, pageIndex: idx }))
  );

  return (
    <div className="results-section">
      <div className="results-header">
        <h3>Extracted Records</h3>
        <div className="results-tabs">
          {results.map((result, index) => (
            <button
              key={index}
              className={`tab ${activePage === index ? 'active' : ''}`}
              onClick={() => setActivePage(index)}
            >
              Page {result.page || index + 1}
              <span className="badge">{result.entries?.length || 0}</span>
            </button>
          ))}
          {results.length > 1 && (
            <button
              className={`tab ${activePage === -1 ? 'active' : ''}`}
              onClick={() => setActivePage(-1)}
            >
              All Pages
              <span className="badge">{allEntries.length}</span>
            </button>
          )}
        </div>
      </div>

      <div className="search-box">
        <input
          type="text"
          placeholder="Search by name, place, or amount..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <span className="search-icon">🔍</span>
      </div>

      <div className="table-container">
        <table className="results-table">
          <thead>
            <tr>
              <th>#</th>
              {activePage === -1 && <th>Page</th>}
              <th>Name</th>
              <th>Place</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {activePage === -1 ? (
              filteredEntries.length > 0 ? (
                filteredEntries.map((entry, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{entry.pageIndex + 1}</td>
                    <td>{entry.name || '-'}</td>
                    <td>{entry.place || '-'}</td>
                    <td className="amount">{entry.amount ? `₹${entry.amount}` : '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="no-records">
                    {searchTerm ? 'No matching records found' : 'No records extracted'}
                  </td>
                </tr>
              )
            ) : (
              filteredEntries.length > 0 ? (
                filteredEntries.map((entry, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{entry.name || '-'}</td>
                    <td>{entry.place || '-'}</td>
                    <td className="amount">{entry.amount ? `₹${entry.amount}` : '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="no-records">
                    {searchTerm ? 'No matching records found' : 'No records extracted'}
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>

      <div className="results-summary">
        <p>
          Showing {filteredEntries.length} of {activePage === -1 ? allEntries.length : entries.length} records
        </p>
      </div>
    </div>
  );
};

export default ResultsTable;